import { Video } from "components/stickyVideoStyles";
import {
  AssetArea,
  DescriptionArea,
  DescriptionTitle,
  GridLayout,
  Image,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

export const ContentLayoutType2 = styled(GridLayout)`
  grid-template:
    "title-area"
    "desc-area"
    "image-area";

  ${TitleArea} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${DescriptionArea} {
    padding-top: 24px;
  }

  ${AssetArea} {
    padding: 60px 0;
  }

  ${DescriptionTitle} {
    margin-bottom: 8px;
  }

  ${mediaMin.xs`
    grid-template:
      "title-area desc-area" 100px
      "image-area image-area" auto / 1fr 1fr;

    ${TitleArea} {
      align-items: inherit;
    }

    ${DescriptionArea} {
      padding-top: 0;
    }

    ${DescriptionTitle} {
      margin-bottom: 16px;
    }

    ${AssetArea} {
      display: flex;
      justify-content: center;
      ${Image}, ${Video} {
        max-width: 468px;
      }
    }
  `};

  ${mediaMin.sm`
    grid-template:
      "image-area title-area" 100px 
      "image-area desc-area" auto / 1fr 1fr;


    ${TitleArea} {
      padding: 40px 0 40px 88px;
    }

    ${DescriptionArea} {
      padding: 60px 0 0 88px;
    }

    ${DescriptionTitle} {
      margin-bottom: 24px;
    }
  `};

  ${mediaMin.lg`
    ${Image}, ${Video} {
      max-width: 610px;
    }
  `};
`;
